'use strict';

angular.module('lmsApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('userGroup', {
                parent: 'entity',
                url: '/userGroup',
                data: {
                    pageTitle: 'lmsApp.userGroup.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/userGroup/userGroups.html',
                        controller: 'UserGroupController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('userGroup');
                        return $translate.refresh();
                    }]
                }
            })
            .state('userGroupDetail', {
                parent: 'entity',
                url: '/userGroup/:id',
                data: {
                    pageTitle: 'lmsApp.userGroup.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/userGroup/userGroup-detail.html',
                        controller: 'UserGroupDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('userGroup');
                        return $translate.refresh();
                    }]
                }
            });
    });
